var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOpenT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9239 -8200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9239 8200)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.317 31.918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.734,22.9H2.29A2.1,2.1,0,0,1,0,20.614C0,17.431,0,13.959,0,10A9.9,9.9,0,0,1,1.94,4.1,10.04,10.04,0,0,1,6.985.47,9.809,9.809,0,0,1,9.993,0,10.01,10.01,0,0,1,20.049,9.984c.017,2.6.013,5.236.009,7.79q0,1.4,0,2.786A2.121,2.121,0,0,1,17.734,22.9ZM3.179,19.7a.822.822,0,0,0,0,1.644h13.7a.822.822,0,0,0,0-1.644ZM10.017,2.091H9.91a7.933,7.933,0,0,0,.143,15.864,7.933,7.933,0,0,0-.036-15.865Z",
    transform: "translate(-9231.348 8174.634)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.734,23.4H2.29a2.8,2.8,0,0,1-2.034-.751A2.791,2.791,0,0,1-.5,20.614c0-3.19,0-6.663,0-10.617A10.4,10.4,0,0,1,1.537,3.806,10.537,10.537,0,0,1,6.832-.006,10.308,10.308,0,0,1,9.993-.5,10.51,10.51,0,0,1,20.549,9.981c.017,2.6.013,5.237.009,7.791v.016q0,1.389,0,2.772a2.87,2.87,0,0,1-.753,2.077A2.833,2.833,0,0,1,17.734,23.4ZM9.993.5A9.309,9.309,0,0,0,7.138.946,9.543,9.543,0,0,0,2.343,4.4,9.4,9.4,0,0,0,.5,10c0,3.954,0,7.426,0,10.616A1.611,1.611,0,0,0,2.29,22.4H17.734a1.636,1.636,0,0,0,1.821-1.837q0-1.385,0-2.773v-.014c0-2.554.008-5.193-.009-7.786A9.51,9.51,0,0,0,9.993.5Zm6.89,21.341H3.179a1.322,1.322,0,0,1,0-2.644h13.7a1.322,1.322,0,0,1,0,2.644ZM3.179,20.2a.322.322,0,0,0,0,.644h13.7a.322.322,0,0,0,0-.644Zm6.875-1.741h-.005A8.433,8.433,0,0,1,9.9,1.592h.114a8.433,8.433,0,0,1,.042,16.865ZM10.017,2.591h-.1a7.433,7.433,0,0,0,.135,14.864,7.433,7.433,0,0,0-.035-14.865Z",
    transform: "translate(-9231.348 8174.634)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4140.59,1848.579c0-.731-.013-1.463,0-2.193.018-.8.423-1.2,1.137-1.174a.9.9,0,0,1,.918.821c.048.474.054.954.059,1.432.009.877-.016,1.755.015,2.632a1.135,1.135,0,0,0,.273.659c.466.526.977,1.014,1.466,1.52a.977.977,0,0,1-.135,1.6.864.864,0,0,1-1.2-.086c-.776-.746-1.543-1.5-2.274-2.291a1.275,1.275,0,0,1-.255-.766C4140.567,1850.016,4140.59,1849.3,4140.59,1848.579Z",
    transform: "translate(-13362.973 6333.76)",
    fill: "#71aff8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenT);
export default __webpack_public_path__ + "static/media/icon-openT.dbe37bd8.svg";
export { ForwardRef as ReactComponent };